module.exports = __webpack_public_path__ + "img/icon-status-00.106b35f2.svg";